/**
 * This file is a part of Amblique's projects.
 *
 * Copyright © Amblique - All Rights Reserved.
 *
 * Unauthorized copying of this file, via any medium is strictly prohibited.
 * Proprietary and confidential.
 */

import React from 'react';

import BaseSeo from '@amblique/base/app/components/seo';

/**
 * @override
 *  - Inject `Typekit`
 */
const Seo = ({children, ...props}) => {
  return (
    <BaseSeo {...props}>
      {children}

      <link crossOrigin="anonymous" href="https://use.typekit.net/kuw8vdx.css" rel="stylesheet" />
    </BaseSeo>
  );
};

Seo.propTypes = BaseSeo.propTypes;

export default Seo;
